import { uniformIndex, type RandomByteSource } from './uniform-index';

const normalizeRounds = (rounds: number): number =>
  Number.isInteger(rounds) && rounds > 0 ? rounds : 3;

export async function fisherYatesShuffle<T>(deck: T[], source: RandomByteSource): Promise<T[]> {
  const shuffled = [...deck];

  for (let index = shuffled.length - 1; index > 0; index -= 1) {
    const swapIndex = await uniformIndex(source, index + 1);
    [shuffled[index], shuffled[swapIndex]] = [shuffled[swapIndex]!, shuffled[index]!];
  }

  return shuffled;
}

export async function bakersTransformShuffle<T>(
  deck: T[],
  sourceFactory: () => RandomByteSource,
  rounds: number,
): Promise<T[]> {
  const normalizedRounds = normalizeRounds(rounds);
  let mixed = [...deck];

  for (let round = 0; round < normalizedRounds; round += 1) {
    mixed = await fisherYatesShuffle(mixed, sourceFactory());
  }

  return mixed;
}
